'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var UpdateRequestButton = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(UpdateRequestButton, _Component);

  function UpdateRequestButton() {
    _classCallCheck(this, UpdateRequestButton);

    return _possibleConstructorReturn(this, (UpdateRequestButton.__proto__ || Object.getPrototypeOf(UpdateRequestButton)).apply(this, arguments));
  }

  _createClass(UpdateRequestButton, [{
    key: 'render',
    value: function render() {
      var fromTask = this.props.fromTask;


      return _react2.default.createElement(
        'div',
        { className: 'footer' },
        _react2.default.createElement(
          _Button2.default,
          { bsStyle: 'primary', bsSize: 'large', disabled: this.props.disabled, type: 'submit' },
          fromTask ? 'Send' : 'Save',
          ' Update'
        ),
        fromTask && _react2.default.createElement(
          'div',
          { className: 'submit-info' },
          'Requester will receive an',
          _react2.default.createElement('br', null),
          'email with the latest update'
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return UpdateRequestButton;
}(_react.Component), _class2.defaultProps = {
  disabled: true,
  fromTask: false
}, _class2.propTypes = {
  disabled: _propTypes2.default.bool,
  fromTask: _propTypes2.default.bool
}, _temp)) || _class;

var _default = UpdateRequestButton;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(UpdateRequestButton, 'UpdateRequestButton', '/app/src/components/page-tasks/UpdateRequestButton.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-tasks/UpdateRequestButton.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtdGFza3MvVXBkYXRlUmVxdWVzdEJ1dHRvbi5qcyJdLCJuYW1lcyI6WyJVcGRhdGVSZXF1ZXN0QnV0dG9uIiwib2JzZXJ2ZXIiLCJmcm9tVGFzayIsInByb3BzIiwiZGlzYWJsZWQiLCJDb21wb25lbnQiLCJkZWZhdWx0UHJvcHMiLCJwcm9wVHlwZXMiLCJQcm9wVHlwZXMiLCJib29sIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQUtNQSxtQixPQURMQyxtQjs7Ozs7Ozs7Ozs7NkJBRVc7QUFBQSxVQUNBQyxRQURBLEdBQ2EsS0FBS0MsS0FEbEIsQ0FDQUQsUUFEQTs7O0FBR1IsYUFDRTtBQUFBO0FBQUEsVUFBSyxXQUFVLFFBQWY7QUFDRTtBQUFDLDBCQUFEO0FBQUEsWUFBUSxTQUFRLFNBQWhCLEVBQTBCLFFBQU8sT0FBakMsRUFBeUMsVUFBVSxLQUFLQyxLQUFMLENBQVdDLFFBQTlELEVBQXdFLE1BQUssUUFBN0U7QUFDR0YscUJBQVcsTUFBWCxHQUFvQixNQUR2QjtBQUFBO0FBQUEsU0FERjtBQUlHQSxvQkFDQztBQUFBO0FBQUEsWUFBSyxXQUFVLGFBQWY7QUFBQTtBQUVFLG1EQUZGO0FBQUE7QUFBQTtBQUxKLE9BREY7QUFjRDs7Ozs7Ozs7Ozs7RUFsQitCRyxnQixXQW9CekJDLFksR0FBZTtBQUNwQkYsWUFBVSxJQURVO0FBRXBCRixZQUFVO0FBRlUsQyxVQUtmSyxTLEdBQVk7QUFDakJILFlBQVVJLG9CQUFVQyxJQURIO0FBRWpCUCxZQUFVTSxvQkFBVUM7QUFGSCxDOztlQU1OVCxtQjs7Ozs7Ozs7Ozs7MEJBL0JUQSxtQiIsImZpbGUiOiJVcGRhdGVSZXF1ZXN0QnV0dG9uLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCB7IG9ic2VydmVyIH0gZnJvbSAnbW9ieC1yZWFjdCc7XG5cbmltcG9ydCB7IEJ1dHRvbiB9IGZyb20gJ3JlYWN0LWJvb3RzdHJhcCc7XG5cbkBvYnNlcnZlclxuY2xhc3MgVXBkYXRlUmVxdWVzdEJ1dHRvbiBleHRlbmRzIENvbXBvbmVudCB7XG4gIHJlbmRlciAoKSB7XG4gICAgY29uc3QgeyBmcm9tVGFzayB9ID0gdGhpcy5wcm9wcztcblxuICAgIHJldHVybiAoXG4gICAgICA8ZGl2IGNsYXNzTmFtZT0nZm9vdGVyJz5cbiAgICAgICAgPEJ1dHRvbiBic1N0eWxlPSdwcmltYXJ5JyBic1NpemU9J2xhcmdlJyBkaXNhYmxlZD17dGhpcy5wcm9wcy5kaXNhYmxlZH0gdHlwZT0nc3VibWl0Jz5cbiAgICAgICAgICB7ZnJvbVRhc2sgPyAnU2VuZCcgOiAnU2F2ZSd9IFVwZGF0ZVxuICAgICAgICA8L0J1dHRvbj5cbiAgICAgICAge2Zyb21UYXNrICYmIChcbiAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT0nc3VibWl0LWluZm8nPlxuICAgICAgICAgICAgUmVxdWVzdGVyIHdpbGwgcmVjZWl2ZSBhblxuICAgICAgICAgICAgPGJyIC8+XG4gICAgICAgICAgICBlbWFpbCB3aXRoIHRoZSBsYXRlc3QgdXBkYXRlXG4gICAgICAgICAgPC9kaXY+XG4gICAgICAgICl9XG4gICAgICA8L2Rpdj5cbiAgICApO1xuICB9XG5cbiAgc3RhdGljIGRlZmF1bHRQcm9wcyA9IHtcbiAgICBkaXNhYmxlZDogdHJ1ZSxcbiAgICBmcm9tVGFzazogZmFsc2UsXG4gIH1cblxuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIGRpc2FibGVkOiBQcm9wVHlwZXMuYm9vbCxcbiAgICBmcm9tVGFzazogUHJvcFR5cGVzLmJvb2wsXG4gIH1cbn1cblxuZXhwb3J0IGRlZmF1bHQgVXBkYXRlUmVxdWVzdEJ1dHRvbjtcbiJdfQ==